var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"fill":"#7F7F7F","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M0 12.464v3.28h3.28L12.95 6.07l-3.28-3.28zM15.487 3.535a.87.87 0 0 0 0-1.233L13.441.256a.87.87 0 0 0-1.233 0l-1.6 1.6 3.279 3.28 1.6-1.6z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }